import objectFitImages from 'object-fit-images';
import '@babel/polyfill';

import './js/resizeAd';
import { handleOpenMenu } from './js/menu';
import {
  resizeBlogList,
  removePaginationsButtons,
  toggleArchiveSection,
  formatAtlWidgetDate,
} from './js/helpers';

import './main.css';

objectFitImages();
handleOpenMenu();
resizeBlogList();
removePaginationsButtons();
toggleArchiveSection();
formatAtlWidgetDate();
